import { createComponent } from '../utils';
import { useSpacer } from './useSpacer';
export default createComponent({
  useHook: useSpacer,
  name: 'Spacer'
});